// 模拟数据 - 用于 quangou、jinfeng、user 用户展示
import { Community } from './api';

// ========== 图片素材（精致、高质量） ==========
export const MOCK_IMAGES = {
  // 用户头像
  avatars: [
    'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&crop=faces',
    'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
    'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
    'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&h=200&fit=crop&crop=faces',
    'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=200&h=200&fit=crop&crop=faces',
    'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop&crop=faces',
    'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop&crop=faces',
    'https://images.unsplash.com/photo-1527980965255-d3b416303d12?w=200&h=200&fit=crop&crop=faces',
    'https://images.unsplash.com/photo-1506798512-7c5e8c8c5b8?w=200&h=200&fit=crop&crop=faces',
    'https://images.unsplash.com/photo-150821814-8c5e8c5b8?w=200&h=200&fit=crop&crop=faces',
    'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=200&h=200&fit=crop&crop=faces',
    'https://images.unsplash.com/photo-1527980965255-d3b416303d12?w=200&h=200&fit=crop&crop=faces',
  ],

  // 社区封面 - 高质量自然风景
  communityCovers: [
    'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&h=400&fit=crop',
    'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=1200&h=400&fit=crop',
    'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1200&h=400&fit=crop',
    'https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=1200&h=400&fit=crop',
    'https://images.unsplash.com/photo-1472214103451-9374bd1c798e?w=1200&h=400&fit=crop',
    'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=1200&h=400&fit=crop',
    'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=1200&h=400&fit=crop',
    'https://images.unsplash.com/photo-1447752875215-b2761acb3c5d?w=1200&h=400&fit=crop',
    'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&h=400&fit=crop',
    'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=1200&h=400&fit=crop',
    'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1200&h=400&fit=crop',
    'https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=1200&h=400&fit=crop',
  ],

  // 产品图片 - 精美产品图
  products: [
    'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500&h=500&fit=crop',
    'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=500&h=500&fit=crop',
    'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=500&h=500&fit=crop',
    'https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=500&h=500&fit=crop',
    'https://images.unsplash.com/photo-1560343090-f0409e92791a?w=500&h=500&fit=crop',
    'https://images.unsplash.com/photo-1585386959984-a4155224a1ad?w=500&h=500&fit=crop',
    'https://images.unsplash.com/photo-1491553895911-0055eca6402d?w=500&h=500&fit=crop',
    'https://images.unsplash.com/photo-1572569028738-411a3ee2fb2f?w=500&h=500&fit=crop',
  ],

  // 艺术文化图片
  artCulture: [
    'https://images.unsplash.com/photo-1577083552433-68167593af61?w=800&h=600&fit=crop',
    'https://images.unsplash.com/photo-1549887534-1541e9326642?w=800&h=600&fit=crop',
    'https://images.unsplash.com/photo-15187092688053-a8d2c3e6db63?w=800&h=600&fit=crop',
    'https://images.unsplash.com/photo-1561214115-f2f134cc4912?w=800&h=600&fit=crop',
    'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=800&h=600&fit=crop',
    'https://images.unsplash.com/photo-1516280440614-37939bbacd81?w=800&h=600&fit=crop',
    'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=800&h=600&fit=crop',
    'https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?w=800&h=600&fit=crop',
  ],
};

// ========== 视频素材（精致视频封面） ==========
export const MOCK_VIDEO_THUMBNAILS = {
  // 视频封面图
  thumbnails: [
    'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=400&h=225&fit=crop',
    'https://images.unsplash.com/photo-1516280440614-37939bbacd81?w=400&h=225&fit=crop',
    'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=225&fit=crop',
    'https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?w=400&h=225&fit=crop',
    'https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=400&h=225&fit=crop',
    'https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=400&h=225&fit=crop',
  ],
};

// ========== 用户数据 ==========
export const MOCK_USERS = [
  {
    id: 'quangou',
    username: 'quangou',
    name: 'quangou',
    avatar: MOCK_IMAGES.avatars[0],
    status: 'online',
    bio: '热爱传统文化，致力于乡村振兴',
    followers: 1256,
    following: 342,
    communities: ['comm-6', 'comm-7', 'comm-8', 'comm-9', 'comm-10', 'comm-11', 'comm-12'],
  },
  {
    id: 'jinfeng',
    username: 'jinfeng',
    name: '金锋',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
    status: 'online',
    bio: '农业科技爱好者，关注智慧农业发展',
    followers: 896,
    following: 234,
    communities: ['comm-1', 'comm-2', 'comm-4', 'comm-6', 'comm-7', 'comm-10', 'comm-12'],
  },
  {
    id: 'user',
    username: 'user',
    name: '用户',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
    status: 'online',
    bio: '传统文化传承者，喜欢探索乡村之美',
    followers: 678,
    following: 189,
    communities: ['comm-1', 'comm-3', 'comm-5', 'comm-8', 'comm-9', 'comm-11', 'comm-12'],
  },
];

// ========== 好友关系数据 ==========
export const MOCK_FRIEND_RELATIONS = [
  {
    userId: 'quangou',
    friendId: 'jinfeng',
    status: 'accepted',
    requestTime: new Date(Date.now() - 10 * 86400000).toISOString(),
    acceptTime: new Date(Date.now() - 9 * 86400000).toISOString(),
  },
  {
    userId: 'quangou',
    friendId: 'user',
    status: 'accepted',
    requestTime: new Date(Date.now() - 8 * 86400000).toISOString(),
    acceptTime: new Date(Date.now() - 7 * 86400000).toISOString(),
  },
  {
    userId: 'jinfeng',
    friendId: 'user',
    status: 'accepted',
    requestTime: new Date(Date.now() - 6 * 86400000).toISOString(),
    acceptTime: new Date(Date.now() - 5 * 86400000).toISOString(),
  },
];

// ========== 社区数据 ==========
export const MOCK_COMMUNITIES: Community[] = [
  {
    id: 'comm-1',
    name: '江南水乡文化社区',
    avatar: MOCK_IMAGES.avatars[0],
    coverImage: MOCK_IMAGES.communityCovers[0],
    category: '文化传承',
    type: 'culture',
    description: '致力于江南水乡文化的传承与保护，分享传统建筑、民俗风情和非遗技艺。',
    memberCount: 3842,
    joinDate: new Date(Date.now() - 30 * 86400000).toISOString(),
    announcement: '欢迎新成员加入！每周六下午举办茶艺交流会。',
    totalPoints: 156800,
    hasLeader: true,
    leaderName: '王秀英',
    leaderAvatar: MOCK_IMAGES.avatars[1],
    leaderVideo: 'https://example.com/leader1.mp4',
  },
  {
    id: 'comm-2',
    name: '现代农业科技社区',
    avatar: MOCK_IMAGES.avatars[2],
    coverImage: MOCK_IMAGES.communityCovers[1],
    category: '科技创新',
    type: 'technology',
    description: '推广智慧农业技术，分享无人机喷洒、智能灌溉、物联网监测等现代农业实践。',
    memberCount: 5210,
    joinDate: new Date(Date.now() - 60 * 86400000).toISOString(),
    announcement: '下月将举办无人机操作培训班，敬请关注！',
    totalPoints: 234500,
    hasLeader: true,
    leaderName: '李建国',
    leaderAvatar: MOCK_IMAGES.avatars[3],
    leaderVideo: 'https://example.com/leader2.mp4',
  },
  {
    id: 'comm-3',
    name: '传统手工艺传承社区',
    avatar: MOCK_IMAGES.avatars[4],
    coverImage: MOCK_IMAGES.communityCovers[2],
    category: '非遗文化',
    type: 'craft',
    description: '传承木雕、剪纸、刺绣等传统手工艺，培养新一代手工艺人。',
    memberCount: 4156,
    joinDate: new Date(Date.now() - 45 * 86400000).toISOString(),
    announcement: '本月工作坊：学习苏绣基本针法',
    totalPoints: 189200,
    hasLeader: true,
    leaderName: '张美玲',
    leaderAvatar: MOCK_IMAGES.avatars[5],
    leaderVideo: 'https://example.com/leader3.mp4',
  },
  {
    id: 'comm-4',
    name: '绿色生态农业社区',
    avatar: MOCK_IMAGES.avatars[6],
    coverImage: MOCK_IMAGES.communityCovers[3],
    category: '生态环保',
    type: 'eco',
    description: '推广有机种植、生态养殖，保护乡村生态环境，发展绿色经济。',
    memberCount: 3589,
    joinDate: new Date(Date.now() - 90 * 86400000).toISOString(),
    announcement: '有机蔬菜认养活动火热进行中',
    totalPoints: 178300,
    hasLeader: true,
    leaderName: '赵立冬',
    leaderAvatar: MOCK_IMAGES.avatars[7],
    leaderVideo: 'https://example.com/leader4.mp4',
  },
  {
    id: 'comm-5',
    name: '乡村振兴故事社区',
    avatar: MOCK_IMAGES.avatars[0],
    coverImage: MOCK_IMAGES.communityCovers[4],
    category: '故事分享',
    type: 'story',
    description: '记录乡村振兴的感人故事，分享成功案例，激励更多人参与乡村建设。',
    memberCount: 6234,
    joinDate: new Date(Date.now() - 15 * 86400000).toISOString(),
    announcement: '欢迎投稿！优秀故事将有机会上墙展示。',
    totalPoints: 87600,
    hasLeader: true,
    leaderName: '陈思雨',
    leaderAvatar: MOCK_IMAGES.avatars[1],
    leaderVideo: 'https://example.com/leader5.mp4',
  },
  {
    id: 'comm-6',
    name: '古韵茶艺文化社区',
    avatar: MOCK_IMAGES.avatars[2],
    coverImage: MOCK_IMAGES.communityCovers[5],
    category: '茶艺文化',
    type: 'tea',
    description: '传承千年茶艺文化，品茗论道，以茶会友。分享茶艺知识、茶具收藏和品茶心得，让茶文化在现代生活中焕发新活力。',
    memberCount: 4821,
    joinDate: new Date(Date.now() - 20 * 86400000).toISOString(),
    announcement: '本周六举办茶艺品鉴会，欢迎茶友参加！',
    totalPoints: 198500,
    hasLeader: true,
    leaderName: 'quangou',
    leaderAvatar: MOCK_IMAGES.avatars[0],
    leaderVideo: 'https://example.com/leader6.mp4',
  },
  {
    id: 'comm-7',
    name: '乡村美食传承社区',
    avatar: MOCK_IMAGES.avatars[3],
    coverImage: MOCK_IMAGES.communityCovers[6],
    category: '美食文化',
    type: 'food',
    description: '挖掘和传承乡村传统美食，分享地方特色菜谱、烹饪技巧和美食故事。让传统美食文化在新时代继续传承发展。',
    memberCount: 5678,
    joinDate: new Date(Date.now() - 25 * 86400000).toISOString(),
    announcement: '征集传统菜谱，优秀作品将获得奖励！',
    totalPoints: 245600,
    hasLeader: true,
    leaderName: 'quangou',
    leaderAvatar: MOCK_IMAGES.avatars[0],
    leaderVideo: 'https://example.com/leader7.mp4',
  },
  {
    id: 'comm-8',
    name: '传统建筑保护社区',
    avatar: MOCK_IMAGES.avatars[4],
    coverImage: MOCK_IMAGES.communityCovers[7],
    category: '建筑文化',
    type: 'architecture',
    description: '保护和传承传统建筑文化，记录古建筑之美，分享建筑修复技术和保护经验。让传统建筑在现代社会中继续发光发热。',
    memberCount: 3245,
    joinDate: new Date(Date.now() - 40 * 86400000).toISOString(),
    announcement: '古建筑摄影大赛正在进行，欢迎投稿！',
    totalPoints: 167800,
    hasLeader: true,
    leaderName: 'quangou',
    leaderAvatar: MOCK_IMAGES.avatars[0],
    leaderVideo: 'https://example.com/leader8.mp4',
  },
  {
    id: 'comm-9',
    name: '乡村音乐艺术社区',
    avatar: MOCK_IMAGES.avatars[5],
    coverImage: MOCK_IMAGES.communityCovers[8],
    category: '音乐艺术',
    type: 'music',
    description: '传承乡村音乐和民间艺术，分享传统乐器演奏、民歌传唱和音乐创作。让乡村音乐在现代舞台上绽放光彩。',
    memberCount: 4123,
    joinDate: new Date(Date.now() - 35 * 86400000).toISOString(),
    announcement: '本周举办线上音乐会，展示传统音乐魅力！',
    totalPoints: 189600,
    hasLeader: true,
    leaderName: 'quangou',
    leaderAvatar: MOCK_IMAGES.avatars[0],
    leaderVideo: 'https://example.com/leader9.mp4',
  },
  {
    id: 'comm-10',
    name: '生态旅游发展社区',
    avatar: MOCK_IMAGES.avatars[6],
    coverImage: MOCK_IMAGES.communityCovers[9],
    category: '生态旅游',
    type: 'tourism',
    description: '发展生态旅游，推广乡村旅游资源，分享旅游攻略和体验。让更多人了解乡村之美，促进乡村振兴。',
    memberCount: 6892,
    joinDate: new Date(Date.now() - 18 * 86400000).toISOString(),
    announcement: '春季旅游路线推荐已发布，快来查看！',
    totalPoints: 312400,
    hasLeader: true,
    leaderName: 'quangou',
    leaderAvatar: MOCK_IMAGES.avatars[0],
    leaderVideo: 'https://example.com/leader10.mp4',
  },
  {
    id: 'comm-11',
    name: '传统节庆文化社区',
    avatar: MOCK_IMAGES.avatars[7],
    coverImage: MOCK_IMAGES.communityCovers[10],
    category: '节庆文化',
    type: 'festival',
    description: '传承和弘扬传统节庆文化，记录节庆活动，分享节庆习俗和传统文化。让传统节庆在现代社会中继续传承。',
    memberCount: 5234,
    joinDate: new Date(Date.now() - 28 * 86400000).toISOString(),
    announcement: '春节活动策划中，欢迎大家提出建议！',
    totalPoints: 223500,
    hasLeader: true,
    leaderName: 'quangou',
    leaderAvatar: MOCK_IMAGES.avatars[0],
    leaderVideo: 'https://example.com/leader11.mp4',
  },
  {
    id: 'comm-12',
    name: '乡村教育发展社区',
    avatar: MOCK_IMAGES.avatars[1],
    coverImage: MOCK_IMAGES.communityCovers[11],
    category: '教育发展',
    type: 'education',
    description: '关注乡村教育发展，分享教育资源、教学经验和教育故事。为乡村孩子提供更好的教育机会，助力乡村振兴。',
    memberCount: 4567,
    joinDate: new Date(Date.now() - 22 * 86400000).toISOString(),
    announcement: '教育资源共享计划启动，欢迎教师加入！',
    totalPoints: 198300,
    hasLeader: true,
    leaderName: 'quangou',
    leaderAvatar: MOCK_IMAGES.avatars[0],
    leaderVideo: 'https://example.com/leader12.mp4',
  },
];

// ========== 产品数据 ==========
export const MOCK_PRODUCTS = [
  {
    id: 'prod-1',
    name: '有机绿茶礼盒',
    price: 299,
    originalPrice: 399,
    image: MOCK_IMAGES.products[0],
    communityId: 'comm-1',
    communityName: '江南水乡文化社区',
    description: '产自高山云雾茶园，手工采摘，传统工艺炒制，清香持久。',
    sales: 2341,
    rating: 4.8,
    stock: 158,
    tags: ['有机', '高山茶', '手工制作'],
  },
  {
    id: 'prod-2',
    name: '智能农业传感器套件',
    price: 1299,
    originalPrice: 1599,
    image: MOCK_IMAGES.products[1],
    communityId: 'comm-2',
    communityName: '现代农业科技社区',
    description: '包含温度、湿度、光照、土壤湿度传感器，支持手机APP远程监控。',
    sales: 892,
    rating: 4.9,
    stock: 45,
    tags: ['智能农业', '物联网', '科技'],
  },
  {
    id: 'prod-3',
    name: '手工木雕摆件',
    price: 899,
    originalPrice: 1299,
    image: MOCK_IMAGES.products[2],
    communityId: 'comm-3',
    communityName: '传统手工艺传承社区',
    description: '非遗传承人亲手雕刻，精选红木，雕刻精美，寓意吉祥。',
    sales: 567,
    rating: 5.0,
    stock: 23,
    tags: ['非遗', '手工', '红木'],
  },
  {
    id: 'prod-4',
    name: '有机蔬菜礼篮',
    price: 199,
    originalPrice: 259,
    image: MOCK_IMAGES.products[3],
    communityId: 'comm-4',
    communityName: '绿色生态农业社区',
    description: '当日采摘，包含8种有机蔬菜，新鲜直达。',
    sales: 1845,
    rating: 4.7,
    stock: 89,
    tags: ['有机', '新鲜', '当日采摘'],
  },
  {
    id: 'prod-5',
    name: '乡村纪录片合集',
    price: 99,
    originalPrice: 199,
    image: MOCK_IMAGES.products[4],
    communityId: 'comm-5',
    communityName: '乡村振兴故事社区',
    description: '收录10部优秀乡村纪录片，展现乡村振兴成果。',
    sales: 1256,
    rating: 4.8,
    stock: 200,
    tags: ['纪录片', '乡村', '视频'],
  },
  {
    id: 'prod-6',
    name: '无人机喷洒服务',
    price: 500,
    originalPrice: 600,
    image: MOCK_IMAGES.products[5],
    communityId: 'comm-2',
    communityName: '现代农业科技社区',
    description: '提供农作物无人机喷洒服务，高效环保，覆盖面积100亩。',
    sales: 342,
    rating: 4.6,
    stock: 999,
    tags: ['服务', '无人机', '农业'],
  },
  {
    id: 'prod-7',
    name: '剪纸艺术品套装',
    price: 358,
    originalPrice: 488,
    image: MOCK_IMAGES.products[6],
    communityId: 'comm-3',
    communityName: '传统手工艺传承社区',
    description: '包含剪纸福字、窗花、喜花等12件，非遗工艺制作。',
    sales: 723,
    rating: 4.9,
    stock: 156,
    tags: ['剪纸', '非遗', '装饰'],
  },
  {
    id: 'prod-8',
    name: '农家蜂蜜礼盒',
    price: 268,
    originalPrice: 338,
    image: MOCK_IMAGES.products[7],
    communityId: 'comm-4',
    communityName: '绿色生态农业社区',
    description: '100%纯天然蜂蜜，无添加，源自深山花海。',
    sales: 1934,
    rating: 4.9,
    stock: 127,
    tags: ['蜂蜜', '天然', '无添加'],
  },
];

// ========== 文章数据 ==========
export const MOCK_ARTICLES = [
  {
    id: 'art-1',
    title: '江南水乡：千年文化的活态传承',
    author: {
      id: 'user-1',
      name: '陈文轩',
      avatar: MOCK_IMAGES.avatars[0],
    },
    coverImage: MOCK_IMAGES.artCulture[0],
    communityId: 'comm-1',
    communityName: '江南水乡文化社区',
    content: `江南水乡是中国独特的水系文化遗产，承载着千年的历史记忆。从苏州园林到乌镇水巷，每一处都展现着中华文化的精髓。

## 水乡建筑特色

江南水乡建筑以白墙黛瓦、小桥流水为特色，充分体现了人与自然的和谐共处。马头墙、天井、石桥等元素构成了独特的水乡风貌。

## 文化传承意义

水乡文化不仅是建筑遗产，更是生活方式的传承。通过茶艺、丝织、评弹等传统文化活动，让千年文化在现代社会焕发新生。

## 保护与开发

在水乡保护中，我们坚持"活态传承"的理念，让居民继续在水乡中生活，让文化在日常生活中延续。`,
    tags: ['水乡文化', '遗产保护', '文化传承'],
    views: 12845,
    likes: 892,
    comments: 234,
    createdAt: '2024-01-15T10:30:00Z',
    isPinned: true,
  },
  {
    id: 'art-2',
    title: '智慧农业：引领乡村振兴新方向',
    author: {
      id: 'user-2',
      name: '李明远',
      avatar: MOCK_IMAGES.avatars[2],
    },
    coverImage: MOCK_IMAGES.artCulture[1],
    communityId: 'comm-2',
    communityName: '现代农业科技社区',
    content: `智慧农业通过物联网、大数据、人工智能等技术，实现农业生产的精准化、智能化管理。

## 技术应用

- **无人机植保**：精准喷洒，减少农药使用
- **智能灌溉**：根据土壤湿度自动调节水量
- **温室监控**：实时监测温度、光照、CO2浓度

## 经济效益

智慧农业提高生产效率30%以上，降低人力成本40%，同时保护生态环境。

## 未来展望

随着5G技术的普及，智慧农业将更加普及，为乡村振兴注入新的动力。`,
    tags: ['智慧农业', '科技', '乡村振兴'],
    views: 9567,
    likes: 654,
    comments: 189,
    createdAt: '2024-01-18T14:20:00Z',
    isPinned: false,
  },
  {
    id: 'art-3',
    title: '非遗传承：让古老技艺焕发新生',
    author: {
      id: 'user-3',
      name: '周小芸',
      avatar: MOCK_IMAGES.avatars[4],
    },
    coverImage: MOCK_IMAGES.artCulture[2],
    communityId: 'comm-3',
    communityName: '传统手工艺传承社区',
    content: `非物质文化遗产是中华民族的文化瑰宝，如何让这些古老技艺在现代社会传承发展，是我们面临的重要课题。

## 面临的挑战

- **传承人老龄化**：许多非遗技艺面临后继无人的困境
- **市场萎缩**：现代工业品冲击传统手工艺市场
- **认知不足**：年轻一代对传统文化了解有限

## 保护措施

1. **建立传承基地**：培养年轻传承人
2. **创新产品设计**：结合现代审美开发新产品
3. **数字化保存**：用视频、VR等技术记录技艺过程
4. **文旅结合**：开发非遗旅游产品

## 成功案例

通过以上措施，越来越多的非遗技艺得到了有效保护和传承，如苏绣、木雕、剪纸等。`,
    tags: ['非遗保护', '手工艺', '文化传承'],
    views: 7632,
    likes: 521,
    comments: 156,
    createdAt: '2024-01-20T09:45:00Z',
    isPinned: true,
  },
  {
    id: 'art-4',
    title: '绿色农业：守护我们的绿水青山',
    author: {
      id: 'user-4',
      name: '张永康',
      avatar: MOCK_IMAGES.avatars[6],
    },
    coverImage: MOCK_IMAGES.artCulture[3],
    communityId: 'comm-4',
    communityName: '绿色生态农业社区',
    content: `发展绿色农业是保护生态环境、实现可持续发展的重要途径。

## 绿色农业原则

- **有机种植**：不使用化学农药和化肥
- **生态循环**：种养结合，资源循环利用
- **生物多样性**：保护农田生态系统

## 实践方式

### 有机蔬菜种植
采用天然肥料，物理防虫，确保蔬菜安全健康。

### 生态养殖
散养家禽家畜，减少集中养殖污染。

### 农产品加工
传统工艺加工，保留营养和风味。

## 社会效益

绿色农业不仅保护环境，还为消费者提供安全食品，增加农民收入，实现生态效益和经济效益的双赢。`,
    tags: ['绿色农业', '生态环保', '可持续发展'],
    views: 11234,
    likes: 734,
    comments: 287,
    createdAt: '2024-01-22T16:15:00Z',
    isPinned: false,
  },
];

// ========== 视频数据 ==========
export const MOCK_VIDEOS = [
  {
    id: 'vid-1',
    title: '江南水乡一日游',
    author: {
      id: 'user-1',
      name: '陈文轩',
      avatar: MOCK_IMAGES.avatars[0],
    },
    thumbnail: MOCK_VIDEO_THUMBNAILS.thumbnails[0],
    communityId: 'comm-1',
    communityName: '江南水乡文化社区',
    duration: '12:34',
    views: 45678,
    likes: 3245,
    comments: 567,
    createdAt: '2024-01-10T08:00:00Z',
    isPinned: true,
  },
  {
    id: 'vid-2',
    title: '智能农业无人机作业展示',
    author: {
      id: 'user-2',
      name: '李明远',
      avatar: MOCK_IMAGES.avatars[2],
    },
    thumbnail: MOCK_VIDEO_THUMBNAILS.thumbnails[1],
    communityId: 'comm-2',
    communityName: '现代农业科技社区',
    duration: '08:45',
    views: 32145,
    likes: 2187,
    comments: 432,
    createdAt: '2024-01-12T14:30:00Z',
    isPinned: false,
  },
  {
    id: 'vid-3',
    title: '木雕技艺传承人现场演示',
    author: {
      id: 'user-3',
      name: '周小芸',
      avatar: MOCK_IMAGES.avatars[4],
    },
    thumbnail: MOCK_VIDEO_THUMBNAILS.thumbnails[2],
    communityId: 'comm-3',
    communityName: '传统手工艺传承社区',
    duration: '15:22',
    views: 28934,
    likes: 1987,
    comments: 398,
    createdAt: '2024-01-14T11:20:00Z',
    isPinned: true,
  },
  {
    id: 'vid-4',
    title: '有机农场的一天',
    author: {
      id: 'user-4',
      name: '张永康',
      avatar: MOCK_IMAGES.avatars[6],
    },
    thumbnail: MOCK_VIDEO_THUMBNAILS.thumbnails[3],
    communityId: 'comm-4',
    communityName: '绿色生态农业社区',
    duration: '10:18',
    views: 38256,
    likes: 2654,
    comments: 489,
    createdAt: '2024-01-16T09:45:00Z',
    isPinned: false,
  },
  {
    id: 'vid-5',
    title: '乡村振兴人物访谈',
    author: {
      id: 'user-5',
      name: '赵思雨',
      avatar: MOCK_IMAGES.avatars[0],
    },
    thumbnail: MOCK_VIDEO_THUMBNAILS.thumbnails[4],
    communityId: 'comm-5',
    communityName: '乡村振兴故事社区',
    duration: '18:56',
    views: 51234,
    likes: 3876,
    comments: 654,
    createdAt: '2024-01-18T15:30:00Z',
    isPinned: true,
  },
  {
    id: 'vid-6',
    title: '传统茶艺展示',
    author: {
      id: 'user-1',
      name: '陈文轩',
      avatar: MOCK_IMAGES.avatars[0],
    },
    thumbnail: MOCK_VIDEO_THUMBNAILS.thumbnails[5],
    communityId: 'comm-1',
    communityName: '江南水乡文化社区',
    duration: '06:32',
    views: 23456,
    likes: 1567,
    comments: 234,
    createdAt: '2024-01-20T10:15:00Z',
    isPinned: false,
  },
];

// ========== 历史人物数据 ==========
export const MOCK_ANCESTORS = [
  {
    id: 'anc-1',
    name: '苏轼',
    era: '宋代（1037-1101）',
    avatar: 'https://images.unsplash.com/photo-1558541409-0b5a2c07c4db?w=200&h=200&fit=crop',
    title: '一代文豪',
    description: '苏轼，字子瞻，号东坡居士，北宋著名文学家、书画家、政治家。其文学成就卓越，诗词文赋皆工，书法绘画亦自成一家。',
    achievements: [
      '创作诗词3400余首',
      '开创豪放派词风',
      '书法位列宋四家',
      '为官清廉，政绩卓著',
    ],
    stories: [
      '被贬黄州期间创作《念奴娇·赤壁怀古》',
      '在杭州西湖修建苏堤，造福百姓',
      '热爱美食，发明东坡肉',
    ],
    images: [
      MOCK_IMAGES.artCulture[0],
      MOCK_IMAGES.artCulture[1],
    ],
    descendants: [
      '苏迈（长子）',
      '苏迨（次子）',
      '苏过（三子）',
    ],
  },
  {
    id: 'anc-2',
    name: '李时珍',
    era: '明代（1518-1593）',
    avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200&h=200&fit=crop',
    title: '药圣',
    description: '李时珍，字东璧，明代著名医药学家。历时27年编成《本草纲目》，被誉为中国医学史上的里程碑。',
    achievements: [
      '编撰《本草纲目》52卷',
      '记载药物1892种',
      '绘制插图1160幅',
      '收录方剂11096首',
    ],
    stories: [
      '游历名山大川，实地考察药材',
      '亲尝百草，验证药性',
      '晚年仍在修订完善著作',
    ],
    images: [
      MOCK_IMAGES.artCulture[2],
      MOCK_IMAGES.artCulture[3],
    ],
    descendants: [
      '李建元（长子）',
      '李建木（次子）',
      '李建方（三子）',
    ],
  },
];

// ========== 好友数据（quangou的好友列表） ==========
export const MOCK_FRIENDS = [
  {
    id: 'jinfeng',
    name: '金锋',
    avatar: MOCK_IMAGES.avatars[1],
    status: 'online',
    lastSeen: new Date().toISOString(),
    mutualFriends: 5,
    communities: ['comm-1', 'comm-2', 'comm-4', 'comm-6', 'comm-7', 'comm-10', 'comm-12'],
    createdAt: new Date(Date.now() - 9 * 86400000).toISOString(),
  },
  {
    id: 'user',
    name: '用户',
    avatar: MOCK_IMAGES.avatars[2],
    status: 'online',
    lastSeen: new Date().toISOString(),
    mutualFriends: 4,
    communities: ['comm-1', 'comm-3', 'comm-5', 'comm-8', 'comm-9', 'comm-11', 'comm-12'],
    createdAt: new Date(Date.now() - 7 * 86400000).toISOString(),
  },
  {
    id: 'friend-1',
    name: '王秀英',
    avatar: MOCK_IMAGES.avatars[3],
    status: 'online',
    lastSeen: new Date().toISOString(),
    mutualFriends: 12,
    communities: [
      'comm-1',
      'comm-3',
    ],
  },
  {
    id: 'friend-2',
    name: '李建国',
    avatar: MOCK_IMAGES.avatars[5],
    status: 'offline',
    lastSeen: new Date(Date.now() - 3600000).toISOString(),
    mutualFriends: 8,
    communities: [
      'comm-2',
    ],
  },
  {
    id: 'friend-3',
    name: '张美玲',
    avatar: MOCK_IMAGES.avatars[7],
    status: 'online',
    lastSeen: new Date().toISOString(),
    mutualFriends: 15,
    communities: [
      'comm-1',
      'comm-3',
      'comm-5',
    ],
  },
  {
    id: 'friend-4',
    name: '赵立冬',
    avatar: MOCK_IMAGES.avatars[9],
    status: 'away',
    lastSeen: new Date(Date.now() - 1800000).toISOString(),
    mutualFriends: 6,
    communities: [
      'comm-4',
    ],
  },
];

// ========== 好友数据（jinfeng的好友列表） ==========
export const MOCK_FRIENDS_JINFENG = [
  {
    id: 'quangou',
    name: 'quangou',
    avatar: MOCK_IMAGES.avatars[0],
    status: 'online',
    lastSeen: new Date().toISOString(),
    mutualFriends: 8,
    communities: ['comm-6', 'comm-7', 'comm-8', 'comm-9', 'comm-10', 'comm-11', 'comm-12'],
    createdAt: new Date(Date.now() - 9 * 86400000).toISOString(),
  },
  {
    id: 'user',
    name: '用户',
    avatar: MOCK_IMAGES.avatars[2],
    status: 'online',
    lastSeen: new Date().toISOString(),
    mutualFriends: 6,
    communities: ['comm-1', 'comm-3', 'comm-5', 'comm-8', 'comm-9', 'comm-11', 'comm-12'],
    createdAt: new Date(Date.now() - 5 * 86400000).toISOString(),
  },
  {
    id: 'jf-friend-1',
    name: '陈建国',
    avatar: MOCK_IMAGES.avatars[10],
    status: 'online',
    lastSeen: new Date().toISOString(),
    mutualFriends: 9,
    communities: ['comm-2', 'comm-4', 'comm-12'],
  },
];

// ========== 好友数据（user的好友列表） ==========
export const MOCK_FRIENDS_USER = [
  {
    id: 'quangou',
    name: 'quangou',
    avatar: MOCK_IMAGES.avatars[0],
    status: 'online',
    lastSeen: new Date().toISOString(),
    mutualFriends: 7,
    communities: ['comm-6', 'comm-7', 'comm-8', 'comm-9', 'comm-10', 'comm-11', 'comm-12'],
    createdAt: new Date(Date.now() - 7 * 86400000).toISOString(),
  },
  {
    id: 'jinfeng',
    name: '金锋',
    avatar: MOCK_IMAGES.avatars[1],
    status: 'online',
    lastSeen: new Date().toISOString(),
    mutualFriends: 6,
    communities: ['comm-1', 'comm-2', 'comm-4', 'comm-6', 'comm-7', 'comm-10', 'comm-12'],
    createdAt: new Date(Date.now() - 5 * 86400000).toISOString(),
  },
  {
    id: 'user-friend-1',
    name: '林小雨',
    avatar: MOCK_IMAGES.avatars[11],
    status: 'online',
    lastSeen: new Date().toISOString(),
    mutualFriends: 11,
    communities: ['comm-1', 'comm-3', 'comm-8', 'comm-11'],
  },
];

// ========== 聊天消息数据 ==========
export const MOCK_CHAT_MESSAGES = [
  {
    id: 'msg-1',
    userId: 'user-1',
    userName: '王秀英',
    userAvatar: MOCK_IMAGES.avatars[1],
    content: '你好！今天社区活动怎么样？',
    timestamp: new Date(Date.now() - 3600000).toISOString(),
    type: 'text',
  },
  {
    id: 'msg-2',
    userId: 'quangou',
    userName: 'quangou',
    userAvatar: MOCK_IMAGES.avatars[0],
    content: '非常成功！大家都积极参与讨论',
    timestamp: new Date(Date.now() - 3000000).toISOString(),
    type: 'text',
  },
  {
    id: 'msg-3',
    userId: 'friend-3',
    userName: '张美玲',
    userAvatar: MOCK_IMAGES.avatars[5],
    content: '明天的茶艺交流会我也要参加',
    timestamp: new Date(Date.now() - 2400000).toISOString(),
    type: 'text',
  },
  {
    id: 'msg-4',
    userId: 'quangou',
    userName: 'quangou',
    userAvatar: MOCK_IMAGES.avatars[0],
    content: '太好了！期待你的分享',
    timestamp: new Date(Date.now() - 1800000).toISOString(),
    type: 'text',
  },
];

// ========== 数字人数据 ==========
export const MOCK_DIGITAL_HUMANS = [
  {
    id: 'dh-1',
    name: '文化传承使者',
    avatar: 'https://images.unsplash.com/photo-1550684848-fac1c5b4e853?w=400&h=400&fit=crop',
    description: '专门用于文化传承讲解的数字人，擅长讲述历史故事和文化传统。',
    voice: '温柔女声',
    language: ['中文', '英文'],
    usage: 1567,
    createdAt: '2024-01-05T10:00:00Z',
  },
  {
    id: 'dh-2',
    name: '农业技术顾问',
    avatar: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=400&h=400&fit=crop',
    description: '提供农业技术咨询的数字人，解答农业生产中的技术问题。',
    voice: '稳重男声',
    language: ['中文'],
    usage: 2345,
    createdAt: '2024-01-08T14:30:00Z',
  },
  {
    id: 'dh-3',
    name: '手工艺导师',
    avatar: 'https://images.unsplash.com/photo-1581090464777-f3220bbe1b8b?w=400&h=400&fit=crop',
    description: '指导传统手工艺学习的数字人，提供详细的教学示范。',
    voice: '亲切女声',
    language: ['中文', '日文'],
    usage: 892,
    createdAt: '2024-01-12T09:15:00Z',
  },
];

// ========== 交友资料数据 ==========
export const MOCK_DATING_PROFILES = [
  {
    id: 'dating-1',
    name: '林小雅',
    age: 26,
    gender: 'female',
    avatar: MOCK_IMAGES.avatars[1],
    images: [MOCK_IMAGES.avatars[1], MOCK_IMAGES.artCulture[0], MOCK_IMAGES.artCulture[1]],
    location: '苏州市',
    occupation: '设计师',
    education: '本科',
    bio: '热爱传统文化，喜欢旅行和摄影。希望能找到志同道合的朋友一起探索世界。',
    interests: ['旅行', '摄影', '传统文化', '美食'],
    height: 165,
    zodiac: '天秤座',
    communityId: 'comm-1',
    verified: true,
    online: true,
  },
  {
    id: 'dating-2',
    name: '王浩然',
    age: 29,
    gender: 'male',
    avatar: MOCK_IMAGES.avatars[3],
    images: [MOCK_IMAGES.avatars[3], MOCK_IMAGES.artCulture[2], MOCK_IMAGES.artCulture[3]],
    location: '杭州市',
    occupation: '软件工程师',
    education: '硕士',
    bio: '工作之余喜欢户外运动和阅读。希望找到一个共同成长、相互支持的伴侣。',
    interests: ['户外运动', '阅读', '科技', '音乐'],
    height: 178,
    zodiac: '处女座',
    communityId: 'comm-2',
    verified: true,
    online: false,
  },
  {
    id: 'dating-3',
    name: '陈诗琪',
    age: 24,
    gender: 'female',
    avatar: MOCK_IMAGES.avatars[5],
    images: [MOCK_IMAGES.avatars[5], MOCK_IMAGES.artCulture[0], MOCK_IMAGES.artCulture[2]],
    location: '南京市',
    occupation: '教师',
    education: '硕士',
    bio: '热爱教育事业，喜欢和孩子在一起。希望能遇到一个热爱生活的人。',
    interests: ['教育', '阅读', '烹饪', '旅游'],
    height: 162,
    zodiac: '双鱼座',
    communityId: 'comm-3',
    verified: false,
    online: true,
  },
  {
    id: 'dating-4',
    name: '刘雨欣',
    age: 27,
    gender: 'female',
    avatar: MOCK_IMAGES.avatars[1],
    images: [MOCK_IMAGES.avatars[1], MOCK_IMAGES.artCulture[1], MOCK_IMAGES.artCulture[3], MOCK_IMAGES.artCulture[4]],
    location: '杭州市',
    occupation: '茶艺师',
    education: '本科',
    bio: '专注于茶艺文化传承，喜欢品茶、读书和旅行。希望找到志同道合的朋友，一起探索生活的美好。',
    interests: ['茶艺', '阅读', '旅行', '摄影', '传统文化'],
    height: 168,
    zodiac: '天秤座',
    communityId: 'comm-6',
    verified: true,
    online: true,
  },
  {
    id: 'dating-5',
    name: '张明轩',
    age: 31,
    gender: 'male',
    avatar: MOCK_IMAGES.avatars[2],
    images: [MOCK_IMAGES.avatars[2], MOCK_IMAGES.artCulture[2], MOCK_IMAGES.artCulture[5]],
    location: '成都市',
    occupation: '建筑师',
    education: '硕士',
    bio: '热爱传统建筑文化，喜欢研究古建筑和现代设计的结合。希望找到一个能理解并支持我事业的人。',
    interests: ['建筑', '设计', '摄影', '旅行', '历史'],
    height: 182,
    zodiac: '摩羯座',
    communityId: 'comm-8',
    verified: true,
    online: false,
  },
  {
    id: 'dating-6',
    name: '赵雅文',
    age: 25,
    gender: 'female',
    avatar: MOCK_IMAGES.avatars[3],
    images: [MOCK_IMAGES.avatars[3], MOCK_IMAGES.artCulture[0], MOCK_IMAGES.artCulture[6], MOCK_IMAGES.artCulture[7]],
    location: '广州市',
    occupation: '美食博主',
    education: '本科',
    bio: '热爱美食和烹饪，喜欢分享传统美食的制作方法。希望能遇到一个同样热爱生活、享受美食的人。',
    interests: ['美食', '烹饪', '摄影', '旅行', '传统文化'],
    height: 165,
    zodiac: '巨蟹座',
    communityId: 'comm-7',
    verified: true,
    online: true,
  },
  {
    id: 'dating-7',
    name: '周文博',
    age: 28,
    gender: 'male',
    avatar: MOCK_IMAGES.avatars[4],
    images: [MOCK_IMAGES.avatars[4], MOCK_IMAGES.artCulture[1], MOCK_IMAGES.artCulture[4]],
    location: '西安市',
    occupation: '音乐教师',
    education: '硕士',
    bio: '专注于传统音乐教学，喜欢演奏古筝和琵琶。希望找到一个能欣赏传统音乐、热爱文化的人。',
    interests: ['音乐', '古筝', '琵琶', '阅读', '传统文化'],
    height: 175,
    zodiac: '水瓶座',
    communityId: 'comm-9',
    verified: true,
    online: false,
  },
  {
    id: 'dating-8',
    name: '孙雨涵',
    age: 26,
    gender: 'female',
    avatar: MOCK_IMAGES.avatars[5],
    images: [MOCK_IMAGES.avatars[5], MOCK_IMAGES.artCulture[2], MOCK_IMAGES.artCulture[5], MOCK_IMAGES.artCulture[6]],
    location: '厦门市',
    occupation: '旅游规划师',
    education: '本科',
    bio: '热爱旅行和探索，专注于乡村旅游规划。希望找到一个能一起旅行、分享生活的人。',
    interests: ['旅行', '摄影', '规划', '美食', '户外运动'],
    height: 163,
    zodiac: '射手座',
    communityId: 'comm-10',
    verified: true,
    online: true,
  },
  {
    id: 'dating-9',
    name: '吴志强',
    age: 30,
    gender: 'male',
    avatar: MOCK_IMAGES.avatars[6],
    images: [MOCK_IMAGES.avatars[6], MOCK_IMAGES.artCulture[3], MOCK_IMAGES.artCulture[7]],
    location: '北京市',
    occupation: '文化研究员',
    education: '博士',
    bio: '专注于传统文化研究，喜欢阅读和写作。希望找到一个能理解学术研究、热爱文化的人。',
    interests: ['研究', '阅读', '写作', '历史', '传统文化'],
    height: 178,
    zodiac: '处女座',
    communityId: 'comm-1',
    verified: true,
    online: false,
  },
  {
    id: 'dating-10',
    name: '郑思雨',
    age: 23,
    gender: 'female',
    avatar: MOCK_IMAGES.avatars[7],
    images: [MOCK_IMAGES.avatars[7], MOCK_IMAGES.artCulture[0], MOCK_IMAGES.artCulture[4], MOCK_IMAGES.artCulture[7]],
    location: '上海市',
    occupation: '活动策划',
    education: '本科',
    bio: '热爱传统文化活动策划，喜欢组织各种文化节庆活动。希望找到一个能一起参与活动、享受生活的人。',
    interests: ['策划', '活动', '传统文化', '摄影', '社交'],
    height: 160,
    zodiac: '双子座',
    communityId: 'comm-11',
    verified: true,
    online: true,
  },
  {
    id: 'dating-11',
    name: '马文涛',
    age: 29,
    gender: 'male',
    avatar: MOCK_IMAGES.avatars[8],
    images: [MOCK_IMAGES.avatars[8], MOCK_IMAGES.artCulture[1], MOCK_IMAGES.artCulture[5]],
    location: '重庆市',
    occupation: '乡村教师',
    education: '本科',
    bio: '在乡村从事教育工作，热爱教育事业和孩子们。希望找到一个能理解并支持教育事业的人。',
    interests: ['教育', '阅读', '运动', '音乐', '公益'],
    height: 176,
    zodiac: '狮子座',
    communityId: 'comm-12',
    verified: true,
    online: false,
  },
  {
    id: 'dating-12',
    name: '黄雅静',
    age: 28,
    gender: 'female',
    avatar: MOCK_IMAGES.avatars[9],
    images: [MOCK_IMAGES.avatars[9], MOCK_IMAGES.artCulture[2], MOCK_IMAGES.artCulture[6], MOCK_IMAGES.artCulture[7]],
    location: '昆明市',
    occupation: '手工艺人',
    education: '专科',
    bio: '专注于传统手工艺制作，喜欢刺绣和编织。希望找到一个能欣赏手工艺、热爱传统文化的人。',
    interests: ['手工艺', '刺绣', '编织', '传统文化', '艺术'],
    height: 164,
    zodiac: '金牛座',
    communityId: 'comm-3',
    verified: true,
    online: true,
  },
];

// ========== jinfeng 用户的数据 ==========

// jinfeng 的文章
export const MOCK_ARTICLES_JINFENG = [
  {
    id: 'jinfeng-art-1',
    title: '智慧农业：无人机在农作物病虫害防治中的应用',
    author: {
      id: 'jinfeng',
      name: '金锋',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
    },
    coverImage: 'https://images.unsplash.com/photo-1473968512647-3e447244af8f?w=800&h=600&fit=crop',
    communityId: 'comm-2',
    communityName: '现代农业科技社区',
    content: `无人机在农业领域的应用越来越广泛，特别是在病虫害防治方面展现出巨大优势。

## 无人机植保的优势

- **精准施药**：通过GPS定位，实现精准喷洒，减少农药浪费
- **效率提升**：每小时可覆盖50-100亩农田，效率是人工的30倍
- **降低成本**：减少人力投入，降低作业成本60%以上
- **安全性高**：避免人员接触农药，保障农民健康

## 实际应用案例

去年夏天，我们社区使用无人机对1000亩水稻进行了病虫害防治，效果显著，水稻产量提高了15%，农药使用量减少了40%。

## 未来展望

随着AI技术的发展，无人机将具备更智能的病虫害识别能力，实现按需施药，进一步提升农业生产效率。`,
    tags: ['无人机', '智慧农业', '病虫害防治', '科技农业'],
    views: 5678,
    likes: 423,
    comments: 87,
    createdAt: '2024-01-25T08:30:00Z',
    isPinned: true,
  },
  {
    id: 'jinfeng-art-2',
    title: '生态农业：有机种植的实践与思考',
    author: {
      id: 'jinfeng',
      name: '金锋',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
    },
    coverImage: 'https://images.unsplash.com/photo-1500937386664-56d1dfef3854?w=800&h=600&fit=crop',
    communityId: 'comm-4',
    communityName: '绿色生态农业社区',
    content: `有机种植是一种尊重自然、顺应生态的农业方式，我在实践中深有体会。

## 有机种植的核心原则

1. **土壤健康管理**：使用有机肥料，保持土壤肥力和微生物多样性
2. **生物多样性保护**：种植多样化作物，建立生态平衡
3. **病虫害综合防治**：利用天敌、轮作等方式防治病虫害
4. **水资源可持续利用**：采用滴灌、渗灌等节水技术

## 我的实践经历

三年前，我开始尝试有机种植。第一年产量有所下降，但第二年土壤状况明显改善，病虫害减少，产量逐渐恢复。现在，我的有机蔬菜深受消费者欢迎。

## 有机农业的价值

有机农业不仅提供健康的食品，更保护了生态环境，实现了经济效益与生态效益的统一。`,
    tags: ['有机农业', '生态种植', '可持续发展', '绿色农业'],
    views: 3892,
    likes: 312,
    comments: 65,
    createdAt: '2024-01-23T14:20:00Z',
    isPinned: false,
  },
  {
    id: 'jinfeng-art-3',
    title: '茶旅融合：传统茶文化的现代传承方式',
    author: {
      id: 'jinfeng',
      name: '金锋',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
    },
    coverImage: 'https://images.unsplash.com/photo-1544787219-7f47ccb76574?w=800&h=600&fit=crop',
    communityId: 'comm-6',
    communityName: '古韵茶艺文化社区',
    content: `茶旅融合是传统茶文化传承的新路径，我参观茶旅融合示范区的经历让我深有感触。

## 茶旅融合的模式

### 体验式茶园
游客可以亲自采茶、制茶，体验茶农的生活，了解茶叶的制作过程。

### 茶文化主题民宿
将茶文化元素融入民宿设计，让游客在住宿中感受茶文化的魅力。

### 茶艺表演
定期举办茶艺表演，展示传统茶艺的精髓。

## 我的体验

上周我参加了茶旅融合体验活动，从采茶、制茶到品茶，全程参与，深刻感受到了茶文化的博大精深。

## 茶旅融合的意义

茶旅融合让更多人了解和喜爱茶文化，同时也带动了乡村经济发展，实现了文化传承与经济发展的双赢。`,
    tags: ['茶文化', '茶旅融合', '文化传承', '乡村旅游'],
    views: 4234,
    likes: 356,
    comments: 72,
    createdAt: '2024-01-21T10:45:00Z',
    isPinned: true,
  },
];

// jinfeng 的视频
export const MOCK_VIDEOS_JINFENG = [
  {
    id: 'jinfeng-vid-1',
    title: '无人机植保作业实拍',
    author: {
      id: 'jinfeng',
      name: '金锋',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
    },
    thumbnail: 'https://images.unsplash.com/photo-1503917988258-f87a78e3c995?w=400&h=225&fit=crop',
    communityId: 'comm-2',
    communityName: '现代农业科技社区',
    duration: '09:23',
    views: 12890,
    likes: 876,
    comments: 123,
    createdAt: '2024-01-24T13:15:00Z',
    isPinned: true,
  },
  {
    id: 'jinfeng-vid-2',
    title: '有机农场的一天',
    author: {
      id: 'jinfeng',
      name: '金锋',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
    },
    thumbnail: 'https://images.unsplash.com/photo-1464226184884-fa280b87c399?w=400&h=225&fit=crop',
    communityId: 'comm-4',
    communityName: '绿色生态农业社区',
    duration: '14:56',
    views: 9876,
    likes: 654,
    comments: 89,
    createdAt: '2024-01-22T09:30:00Z',
    isPinned: false,
  },
  {
    id: 'jinfeng-vid-3',
    title: '采茶与制茶过程展示',
    author: {
      id: 'jinfeng',
      name: '金锋',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
    },
    thumbnail: 'https://images.unsplash.com/photo-1597055181300-e3633a917c70?w=400&h=225&fit=crop',
    communityId: 'comm-6',
    communityName: '古韵茶艺文化社区',
    duration: '11:34',
    views: 15678,
    likes: 1023,
    comments: 145,
    createdAt: '2024-01-20T14:45:00Z',
    isPinned: true,
  },
];

// jinfeng 的产品
export const MOCK_PRODUCTS_JINFENG = [
  {
    id: 'jinfeng-prod-1',
    name: '高山有机茶礼盒',
    price: 399,
    originalPrice: 499,
    image: 'https://images.unsplash.com/photo-1556881286-fc6915169721?w=500&h=500&fit=crop',
    communityId: 'comm-6',
    communityName: '古韵茶艺文化社区',
    description: '源自海拔800米以上的有机茶园，手工采摘，传统工艺炒制，清香持久。',
    sales: 1567,
    rating: 4.9,
    stock: 89,
    tags: ['有机茶', '高山茶', '手工制作'],
    seller: '金锋',
    sellerAvatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
  },
  {
    id: 'jinfeng-prod-2',
    name: '有机大米礼盒',
    price: 168,
    originalPrice: 218,
    image: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=500&h=500&fit=crop',
    communityId: 'comm-4',
    communityName: '绿色生态农业社区',
    description: '有机种植，不使用农药化肥，营养丰富，口感软糯。',
    sales: 2341,
    rating: 4.8,
    stock: 156,
    tags: ['有机', '大米', '生态'],
    seller: '金锋',
    sellerAvatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
  },
  {
    id: 'jinfeng-prod-3',
    name: '智能农业监测设备',
    price: 899,
    originalPrice: 1199,
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=500&h=500&fit=crop',
    communityId: 'comm-2',
    communityName: '现代农业科技社区',
    description: '实时监测温度、湿度、土壤pH值，支持手机APP远程查看。',
    sales: 456,
    rating: 4.7,
    stock: 67,
    tags: ['智能', '监测', '农业科技'],
    seller: '金锋',
    sellerAvatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
  },
];

// ========== user 用户的数据 ==========

// user 的文章
export const MOCK_ARTICLES_USER = [
  {
    id: 'user-art-1',
    title: '传统手工艺：让古老技艺在现代焕发新生',
    author: {
      id: 'user',
      name: '用户',
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
    },
    coverImage: 'https://images.unsplash.com/photo-1558448204-69c7d3d8c6b3?w=800&h=600&fit=crop',
    communityId: 'comm-3',
    communityName: '传统手工艺传承社区',
    content: `传统手工艺是中华民族的文化瑰宝，如何在现代社会传承发展，是我们需要思考的问题。

## 手工艺面临的挑战

- **传承人老龄化**：年轻人对传统手工艺兴趣不足
- **市场萎缩**：工业化产品冲击传统手工艺市场
- **创新不足**：产品设计缺乏创新，难以满足现代需求

## 传承与创新

在传承的基础上进行创新，是手工艺发展的关键。我们可以：

1. **与现代设计结合**：将传统技艺与现代设计理念融合
2. **开发实用产品**：让手工艺品走进日常生活
3. **培养年轻传承人**：建立手工艺培训基地

## 我的实践

我学习剪纸已有三年，将传统剪纸与现代图案结合，创作了一系列深受年轻人喜爱的作品。

## 手工艺的未来

只要我们用心传承、勇于创新，传统手工艺必将在现代社会焕发新的生机。`,
    tags: ['传统手工艺', '非遗', '文化传承', '创新'],
    views: 4567,
    likes: 387,
    comments: 76,
    createdAt: '2024-01-26T11:20:00Z',
    isPinned: true,
  },
  {
    id: 'user-art-2',
    title: '古建筑之美：传统建筑的保护与传承',
    author: {
      id: 'user',
      name: '用户',
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
    },
    coverImage: 'https://images.unsplash.com/photo-15187092688053-a8d2c3e6db63?w=800&h=600&fit=crop',
    communityId: 'comm-8',
    communityName: '传统建筑保护社区',
    content: `传统建筑承载着深厚的历史文化内涵，保护和传承传统建筑文化是我们的责任。

## 传统建筑的特色

### 江南民居
白墙黛瓦、小桥流水，体现人与自然的和谐。

### 北方四合院
布局严谨、功能齐全，展现传统文化的礼制。

### 徽派建筑
马头墙、天井、精美的砖雕木雕，艺术价值极高。

## 保护的重要性

传统建筑是历史文化的载体，是不可再生的文化资源。保护传统建筑，就是保护我们的文化根脉。

## 我的保护经历

去年，我参与了一座古民居的修缮工作，虽然辛苦，但看到古建筑重现风采，感到无比欣慰。

## 传承与发展

保护传统建筑不是一成不变，要在保护的基础上合理利用，让古建筑在现代社会中发挥新的价值。`,
    tags: ['古建筑', '建筑文化', '遗产保护', '传统文化'],
    views: 6234,
    likes: 523,
    comments: 98,
    createdAt: '2024-01-24T15:45:00Z',
    isPinned: true,
  },
  {
    id: 'user-art-3',
    title: '乡村音乐：传统音乐的传承之路',
    author: {
      id: 'user',
      name: '用户',
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
    },
    coverImage: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=800&h=600&fit=crop',
    communityId: 'comm-9',
    communityName: '乡村音乐艺术社区',
    content: `乡村音乐承载着劳动人民的情感和智慧，是传统文化的重要组成部分。

## 乡村音乐的特点

- **源于生活**：音乐内容反映农村生活和劳动场景
- **旋律优美**：曲调简洁明快，朗朗上口
- **情感真挚**：表达劳动人民的喜怒哀乐
- **地域特色**：不同地区有独特的音乐风格

## 传统乐器

### 古筝
中国古老弹拨乐器，音色优美，表现力丰富。

### 琵琶
四弦乐器，音域宽广，演奏技巧丰富。

### 笛子
传统吹奏乐器，音色清脆明亮。

## 我的音乐之路

我学习古筝已有五年，虽然过程艰辛，但每当弹奏出优美的旋律，所有的付出都值得。

## 音乐传承的意义

传承乡村音乐，就是传承劳动人民的精神和情感，让传统文化在音乐中延续。`,
    tags: ['乡村音乐', '传统乐器', '古筝', '文化传承'],
    views: 3892,
    likes: 345,
    comments: 67,
    createdAt: '2024-01-22T10:30:00Z',
    isPinned: false,
  },
];

// user 的视频
export const MOCK_VIDEOS_USER = [
  {
    id: 'user-vid-1',
    title: '剪纸技艺演示',
    author: {
      id: 'user',
      name: '用户',
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
    },
    thumbnail: 'https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=400&h=225&fit=crop',
    communityId: 'comm-3',
    communityName: '传统手工艺传承社区',
    duration: '12:45',
    views: 8765,
    likes: 543,
    comments: 87,
    createdAt: '2024-01-25T14:20:00Z',
    isPinned: true,
  },
  {
    id: 'user-vid-2',
    title: '古建筑探访之旅',
    author: {
      id: 'user',
      name: '用户',
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
    },
    thumbnail: 'https://images.unsplash.com/photo-1502005229762-cf1b2da7c5d6?w=400&h=225&fit=crop',
    communityId: 'comm-8',
    communityName: '传统建筑保护社区',
    duration: '18:34',
    views: 11234,
    likes: 789,
    comments: 123,
    createdAt: '2024-01-23T09:15:00Z',
    isPinned: true,
  },
  {
    id: 'user-vid-3',
    title: '古筝演奏：高山流水',
    author: {
      id: 'user',
      name: '用户',
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
    },
    thumbnail: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=400&h=225&fit=crop',
    communityId: 'comm-9',
    communityName: '乡村音乐艺术社区',
    duration: '07:23',
    views: 6543,
    likes: 456,
    comments: 67,
    createdAt: '2024-01-21T16:45:00Z',
    isPinned: false,
  },
];

// user 的产品
export const MOCK_PRODUCTS_USER = [
  {
    id: 'user-prod-1',
    name: '手工剪纸套装',
    price: 158,
    originalPrice: 198,
    image: 'https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=500&h=500&fit=crop',
    communityId: 'comm-3',
    communityName: '传统手工艺传承社区',
    description: '包含剪纸工具、纸张和图案模板，适合初学者学习。',
    sales: 1890,
    rating: 4.8,
    stock: 234,
    tags: ['剪纸', '手工', '非遗'],
    seller: '用户',
    sellerAvatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
  },
  {
    id: 'user-prod-2',
    name: '古筝入门教程',
    price: 299,
    originalPrice: 399,
    image: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=500&h=500&fit=crop',
    communityId: 'comm-9',
    communityName: '乡村音乐艺术社区',
    description: '包含视频教程、曲谱和练习曲，适合零基础学习者。',
    sales: 1234,
    rating: 4.9,
    stock: 156,
    tags: ['古筝', '教程', '传统乐器'],
    seller: '用户',
    sellerAvatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
  },
  {
    id: 'user-prod-3',
    name: '古建筑明信片套装',
    price: 68,
    originalPrice: 88,
    image: 'https://images.unsplash.com/photo-15187092688053-a8d2c3e6db63?w=500&h=500&fit=crop',
    communityId: 'comm-8',
    communityName: '传统建筑保护社区',
    description: '收录12张精美的古建筑照片，每张都配有介绍文字。',
    sales: 2567,
    rating: 4.7,
    stock: 345,
    tags: ['古建筑', '明信片', '摄影'],
    seller: '用户',
    sellerAvatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
  },
];

// ========== 扩展的社区数据（jinfeng和user创建的社区） ==========
export const MOCK_COMMUNITIES_EXTENDED = [
  {
    id: 'comm-13',
    name: '智慧农业实践社区',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
    coverImage: 'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=1200&h=400&fit=crop',
    category: '农业科技',
    type: 'technology',
    description: '分享智慧农业实践经验，推广现代农业技术应用，助力农业现代化发展。',
    memberCount: 2134,
    joinDate: new Date(Date.now() - 5 * 86400000).toISOString(),
    announcement: '欢迎加入智慧农业实践社区！',
    totalPoints: 89600,
    hasLeader: true,
    leaderName: 'jinfeng',
    leaderAvatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
    leaderVideo: 'https://example.com/leader13.mp4',
    createdBy: 'jinfeng',
  },
  {
    id: 'comm-14',
    name: '传统手工艺创新社区',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
    coverImage: 'https://images.unsplash.com/photo-1452860606245-08befc0ff44b?w=1200&h=400&fit=crop',
    category: '手工艺',
    type: 'craft',
    description: '致力于传统手工艺的创新与发展，让古老技艺在现代社会焕发新生。',
    memberCount: 1876,
    joinDate: new Date(Date.now() - 3 * 86400000).toISOString(),
    announcement: '手工艺创新大赛即将开始，敬请关注！',
    totalPoints: 76500,
    hasLeader: true,
    leaderName: 'user',
    leaderAvatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
    leaderVideo: 'https://example.com/leader14.mp4',
    createdBy: 'user',
  },
  {
    id: 'comm-15',
    name: '乡村振兴交流社区',
    avatar: MOCK_IMAGES.avatars[0],
    coverImage: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1200&h=400&fit=crop',
    category: '乡村振兴',
    type: 'story',
    description: '分享乡村振兴的成功案例和经验，探讨乡村发展之路，助力乡村振兴战略。',
    memberCount: 3456,
    joinDate: new Date(Date.now() - 7 * 86400000).toISOString(),
    announcement: '乡村振兴故事征集活动进行中',
    totalPoints: 123400,
    hasLeader: true,
    leaderName: 'quangou',
    leaderAvatar: MOCK_IMAGES.avatars[0],
    leaderVideo: 'https://example.com/leader15.mp4',
    createdBy: 'quangou',
  },
];

// ========== 扩展的聊天消息数据 ==========
export const MOCK_CHAT_MESSAGES_EXTENDED = [
  // quangou 与 jinfeng 的对话
  {
    id: 'chat-qg-jf-1',
    userId: 'jinfeng',
    userName: '金锋',
    userAvatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
    content: 'quangou，你创建的古韵茶艺文化社区太棒了！',
    timestamp: new Date(Date.now() - 7200000).toISOString(),
    type: 'text',
  },
  {
    id: 'chat-qg-jf-2',
    userId: 'quangou',
    userName: 'quangou',
    userAvatar: MOCK_IMAGES.avatars[0],
    content: '谢谢！你的智慧农业实践社区也很厉害，学到了很多东西',
    timestamp: new Date(Date.now() - 6000000).toISOString(),
    type: 'text',
  },
  {
    id: 'chat-qg-jf-3',
    userId: 'jinfeng',
    userName: '金锋',
    userAvatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
    content: '周末要不要一起去有机农场参观？',
    timestamp: new Date(Date.now() - 4800000).toISOString(),
    type: 'text',
  },
  {
    id: 'chat-qg-jf-4',
    userId: 'quangou',
    userName: 'quangou',
    userAvatar: MOCK_IMAGES.avatars[0],
    content: '好的！我很乐意去',
    timestamp: new Date(Date.now() - 3600000).toISOString(),
    type: 'text',
  },
  // quangou 与 user 的对话
  {
    id: 'chat-qg-user-1',
    userId: 'user',
    userName: '用户',
    userAvatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
    content: '你好，我是新加入的成员',
    timestamp: new Date(Date.now() - 5400000).toISOString(),
    type: 'text',
  },
  {
    id: 'chat-qg-user-2',
    userId: 'quangou',
    userName: 'quangou',
    userAvatar: MOCK_IMAGES.avatars[0],
    content: '欢迎！很高兴认识你',
    timestamp: new Date(Date.now() - 4800000).toISOString(),
    type: 'text',
  },
  {
    id: 'chat-qg-user-3',
    userId: 'user',
    userName: '用户',
    userAvatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
    content: '我想学习古筝，你能推荐一些资源吗？',
    timestamp: new Date(Date.now() - 3600000).toISOString(),
    type: 'text',
  },
  {
    id: 'chat-qg-user-4',
    userId: 'quangou',
    userName: 'quangou',
    userAvatar: MOCK_IMAGES.avatars[0],
    content: '当然！我可以介绍一位古筝老师给你',
    timestamp: new Date(Date.now() - 3000000).toISOString(),
    type: 'text',
  },
  // jinfeng 与 user 的对话
  {
    id: 'chat-jf-user-1',
    userId: 'jinfeng',
    userName: '金锋',
    userAvatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
    content: '听说你剪纸很厉害？',
    timestamp: new Date(Date.now() - 1800000).toISOString(),
    type: 'text',
  },
  {
    id: 'chat-jf-user-2',
    userId: 'user',
    userName: '用户',
    userAvatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
    content: '哈哈，只是爱好，还有很多要学习',
    timestamp: new Date(Date.now() - 1200000).toISOString(),
    type: 'text',
  },
  {
    id: 'chat-jf-user-3',
    userId: 'jinfeng',
    userName: '金锋',
    userAvatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
    content: '下次可以教教我',
    timestamp: new Date(Date.now() - 600000).toISOString(),
    type: 'text',
  },
];

// ========== 社区成员数据（各社区的成员） ==========
export const MOCK_COMMUNITY_MEMBERS = {
  'comm-1': [
    { userId: 'quangou', role: 'member', joinedAt: new Date(Date.now() - 60 * 86400000).toISOString() },
    { userId: 'jinfeng', role: 'member', joinedAt: new Date(Date.now() - 30 * 86400000).toISOString() },
    { userId: 'user', role: 'member', joinedAt: new Date(Date.now() - 45 * 86400000).toISOString() },
  ],
  'comm-2': [
    { userId: 'jinfeng', role: 'member', joinedAt: new Date(Date.now() - 90 * 86400000).toISOString() },
    { userId: 'quangou', role: 'member', joinedAt: new Date(Date.now() - 60 * 86400000).toISOString() },
  ],
  'comm-3': [
    { userId: 'user', role: 'member', joinedAt: new Date(Date.now() - 75 * 86400000).toISOString() },
    { userId: 'quangou', role: 'member', joinedAt: new Date(Date.now() - 40 * 86400000).toISOString() },
  ],
  'comm-4': [
    { userId: 'jinfeng', role: 'member', joinedAt: new Date(Date.now() - 50 * 86400000).toISOString() },
    { userId: 'quangou', role: 'member', joinedAt: new Date(Date.now() - 90 * 86400000).toISOString() },
  ],
  'comm-5': [
    { userId: 'user', role: 'member', joinedAt: new Date(Date.now() - 15 * 86400000).toISOString() },
    { userId: 'quangou', role: 'member', joinedAt: new Date(Date.now() - 15 * 86400000).toISOString() },
  ],
  'comm-6': [
    { userId: 'quangou', role: 'leader', joinedAt: new Date(Date.now() - 20 * 86400000).toISOString() },
    { userId: 'jinfeng', role: 'member', joinedAt: new Date(Date.now() - 15 * 86400000).toISOString() },
  ],
  'comm-7': [
    { userId: 'quangou', role: 'leader', joinedAt: new Date(Date.now() - 25 * 86400000).toISOString() },
    { userId: 'jinfeng', role: 'member', joinedAt: new Date(Date.now() - 20 * 86400000).toISOString() },
  ],
  'comm-8': [
    { userId: 'quangou', role: 'leader', joinedAt: new Date(Date.now() - 40 * 86400000).toISOString() },
    { userId: 'user', role: 'member', joinedAt: new Date(Date.now() - 35 * 86400000).toISOString() },
  ],
  'comm-9': [
    { userId: 'quangou', role: 'leader', joinedAt: new Date(Date.now() - 35 * 86400000).toISOString() },
    { userId: 'user', role: 'member', joinedAt: new Date(Date.now() - 30 * 86400000).toISOString() },
  ],
  'comm-10': [
    { userId: 'quangou', role: 'leader', joinedAt: new Date(Date.now() - 18 * 86400000).toISOString() },
    { userId: 'jinfeng', role: 'member', joinedAt: new Date(Date.now() - 12 * 86400000).toISOString() },
  ],
  'comm-11': [
    { userId: 'quangou', role: 'leader', joinedAt: new Date(Date.now() - 28 * 86400000).toISOString() },
    { userId: 'user', role: 'member', joinedAt: new Date(Date.now() - 22 * 86400000).toISOString() },
  ],
  'comm-12': [
    { userId: 'quangou', role: 'leader', joinedAt: new Date(Date.now() - 22 * 86400000).toISOString() },
    { userId: 'jinfeng', role: 'member', joinedAt: new Date(Date.now() - 17 * 86400000).toISOString() },
    { userId: 'user', role: 'member', joinedAt: new Date(Date.now() - 15 * 86400000).toISOString() },
  ],
  'comm-13': [
    { userId: 'jinfeng', role: 'leader', joinedAt: new Date(Date.now() - 5 * 86400000).toISOString() },
    { userId: 'quangou', role: 'member', joinedAt: new Date(Date.now() - 3 * 86400000).toISOString() },
    { userId: 'user', role: 'member', joinedAt: new Date(Date.now() - 2 * 86400000).toISOString() },
  ],
  'comm-14': [
    { userId: 'user', role: 'leader', joinedAt: new Date(Date.now() - 3 * 86400000).toISOString() },
    { userId: 'quangou', role: 'member', joinedAt: new Date(Date.now() - 2 * 86400000).toISOString() },
    { userId: 'jinfeng', role: 'member', joinedAt: new Date(Date.now() - 1 * 86400000).toISOString() },
  ],
  'comm-15': [
    { userId: 'quangou', role: 'leader', joinedAt: new Date(Date.now() - 7 * 86400000).toISOString() },
    { userId: 'jinfeng', role: 'member', joinedAt: new Date(Date.now() - 6 * 86400000).toISOString() },
    { userId: 'user', role: 'member', joinedAt: new Date(Date.now() - 5 * 86400000).toISOString() },
  ],
};

// ========== 聊天房间数据（三个用户之间的群聊） ==========
export const MOCK_CHAT_ROOMS = [
  {
    id: 'room-quangou-jinfeng',
    name: 'quangou & 金锋',
    type: 'private',
    participants: ['quangou', 'jinfeng'],
    createdAt: new Date(Date.now() - 9 * 86400000).toISOString(),
    lastMessage: '好的！我很乐意去',
    lastMessageTime: new Date(Date.now() - 3600000).toISOString(),
    unreadCount: { quangou: 0, jinfeng: 0 },
  },
  {
    id: 'room-quangou-user',
    name: 'quangou & 用户',
    type: 'private',
    participants: ['quangou', 'user'],
    createdAt: new Date(Date.now() - 7 * 86400000).toISOString(),
    lastMessage: '当然！我可以介绍一位古筝老师给你',
    lastMessageTime: new Date(Date.now() - 3000000).toISOString(),
    unreadCount: { quangou: 0, user: 0 },
  },
  {
    id: 'room-jinfeng-user',
    name: '金锋 & 用户',
    type: 'private',
    participants: ['jinfeng', 'user'],
    createdAt: new Date(Date.now() - 5 * 86400000).toISOString(),
    lastMessage: '下次可以教教我',
    lastMessageTime: new Date(Date.now() - 600000).toISOString(),
    unreadCount: { jinfeng: 0, user: 0 },
  },
  {
    id: 'room-group-three',
    name: '三人交流群',
    type: 'group',
    participants: ['quangou', 'jinfeng', 'user'],
    createdAt: new Date(Date.now() - 4 * 86400000).toISOString(),
    lastMessage: '大家一起参加社区活动吧',
    lastMessageTime: new Date(Date.now() - 120000).toISOString(),
    unreadCount: { quangou: 0, jinfeng: 0, user: 0 },
  },
];
